import {useState, useEffect} from 'react'
import quizQuestions from '../components/Quiz-question'
const API_URL = 'https://restcountries.com/v3.1/all'

function randomFunction(item) {
    return item[Math.floor(Math.random() * item.length)]
}

function FetchingData() {
    const [ quizData, setQuizData ] = useState([]) 
    const [ loading, setLoading ] = useState(true)
    
    async function fetchData(id) {
        const response = await fetch(API_URL)
        try {
            const result = await response.json()
        
            const randomQuestion = randomFunction(quizQuestions)

            // Random correct answer
            const randomAnswer = randomFunction(result)
            const leftCountries = result.filter(country => country !== randomAnswer)
            
            const opt1 = randomFunction(leftCountries);
            const opt2 = randomFunction(leftCountries);
            const opt3 = randomFunction(leftCountries);
            
            const answerOptions = [ randomAnswer.name.common, randomFunction(leftCountries).name.common, randomFunction(leftCountries).name.common, randomFunction(leftCountries).name.common]
            const sortedAnswerOptions = answerOptions.sort(() => { return 0.5 - Math.random() });
        
            const quizDataObject = {
                question: randomQuestion,
                countries: randomAnswer,
                flag: randomAnswer.flags.png,
                capital: randomAnswer.capital[0],
                answers: sortedAnswerOptions,
                correctAnswer: randomAnswer.name.common,
                userAnswer: '',
                isCorrect: false,
            }
            setLoading(false)
            setQuizData([quizDataObject])
        } catch (error) {
            return error
        }
    }
    
    useEffect(() => {
        fetchData()
    }, [])

    return { loading, setLoading, quizData, fetchData }

}

export default FetchingData